import { useDocFlowEmailSettings } from '../../DocFlow.hooks'
import { DocFlowSendingWidgetProcessFieldName } from '../../DocFlowSending'
import { DocFlowSendingWidgetContent } from '../DocFlowSendingWidgetContent'

function DocFlowSendingEmailSettingsWidget({ index, ...restProps }) {
  const { handleClickNext, handleClickPrevious, isError, notifications } =
    useDocFlowEmailSettings({ index })

  return (
    <DocFlowSendingWidgetContent
      {...restProps}
      index={index}
      isError={isError}
      notifications={notifications}
      widgetStatusFieldName={
        DocFlowSendingWidgetProcessFieldName.EmailSettingsPhase
      }
      onClickPrevious={handleClickPrevious}
      onSubmit={handleClickNext}
    />
  )
}

export default DocFlowSendingEmailSettingsWidget
